import axios from 'axios'

function unwrapResponse(response) {
  const payload = response?.data
  if (payload && typeof payload === 'object' && 'data' in payload && 'code' in payload) {
    if (payload.code !== 200) {
      throw new Error(payload.msg || '加载反馈数据失败')
    }
    return { data: payload.data }
  }
  return response
}

export function listAgentFeedback(params = {}) {
  return axios.get('/api/agent-feedback/list', { params }).then(unwrapResponse)
}

export function getAgentFeedbackStats(params = {}) {
  return axios.get('/api/agent-feedback/stats', { params }).then(unwrapResponse)
}

export function getAiServiceBaseUrl() {
  return '/api/agent-feedback'
}
